export var messageWidth = 700;
export var defaultBodyBorderWidth = 0;
export var defaultBodyBorderColor = '#000000';
export var defaultBodyBorderStyle = 'solid';
//# sourceMappingURL=message-defaults.js.map